import { render, staticRenderFns } from "./MealItem.vue?vue&type=template&id=04d990f2&scoped=true"
import script from "./MealItem.vue?vue&type=script&lang=js"
export * from "./MealItem.vue?vue&type=script&lang=js"
import style0 from "./MealItem.vue?vue&type=style&index=0&id=04d990f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d990f2",
  null
  
)

export default component.exports